import document from '../images/document.svg'
import voice from '../images/voice.svg'
import video from '../images/camara.svg'
import people from '../images/people.svg'
import {useTranslation } from 'react-i18next';

const Services = () => {
    const {t} = useTranslation()
    return (
        <section> 
            <h2 className='text-center text-orange-600 text-3xl '>
                {t('servicesh2')}   
            </h2>
            
            <div className='lg:flex lg:wrap lg:flex-wrap lg:justify-evenly'>
                <div className="max-w-sm rounded overflow-hidden shadow-2xl mx-auto my-8 lg:px-6 lg:mx-16">
                    <img src={document} alt="colorful desktop showing a document with letter A and another document showing a japanese caracter with arrows ponting towards each other" className='mx-auto' />
                    <div className="px-6 py-4">
                        <h3 className="font-bold text-xl mb-2 text-orange-600">{t('serv1h3')}</h3>
                        <p className="text-gray-700 text-base">
                        {t('serv1p1')}
                        </p> <br />
                        <p className="text-gray-700 text-base">
                        {t('serv1p2')}
                        </p> <br />
                        <p className="text-gray-700 text-sm italic">{t('serv1p3')}</p>
                    </div>
                </div>
                <div className="max-w-sm rounded overflow-hidden shadow-2xl mx-auto my-8 lg:px-6 lg:mx-16">
                    <img src={voice} alt="animated person taltking to a micrphone, and sound is visible" className='mx-auto' />
                    <div className="px-6 py-4">
                        <h3 className="font-bold text-xl mb-2 text-orange-600">{t('serv2h3')}</h3>
                        <p className="text-gray-700 text-base">
                        {t('serv2p1')}
                        </p> <br />
                        <p className="text-gray-700 text-base italic">
                        {t('serv2p2')}
                        </p> <br />
                        <p className="text-gray-700 text-base">{t('serv2p3')}</p> 
                        <br /> <p className="text-gray-700 text-base">{t('serv2p4')}</p> <br />    
                        <p className="text-gray-700 text-base italic" >{t('serv2p5')}</p>
                    </div>
                </div>
                <div className="max-w-sm rounded overflow-hidden shadow-2xl mx-auto my-8 lg:px-6 lg:mx-16">
                    <img src={video} alt="a computer showing 5 people in different screens and recording it" className='mx-auto' width={150}/>
                    <div className="px-6 py-4">
                    
                        <h3 className="font-bold text-xl mb-2 text-orange-600">{t('serv3h3')}</h3>
                    
                    
                        <p className="text-gray-700 text-base">
                        {t('serv3p1')}
                        </p> <br />
                    
                    
                        <p className="text-gray-700 text-base">{t('serv3p2')}</p> <br />
                    
                        <p className="text-gray-700 text-base">{t('serv3p3')}</p>
                 
                    </div>
                </div>
                <div className="max-w-sm rounded overflow-hidden shadow-2xl mx-auto my-8 lg:px-6 lg:mx-16">
                    <img src={people} alt="five different people in animated style, with buuble dialogues each " className='mx-auto' width={200}/>
                    <div className="px-6 py-4">
                        
                        <h3 className="font-bold text-xl mb-2 text-orange-600">{t('serv4h3')}</h3>
                        
                        <p className="text-gray-700 text-base">
                        {t('serv4p1')}
                            </p> <br />
                        
                        <p className="text-gray-700 text-base">{t('serv4p2')}</p>
                        
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Services